export type ChipItems = {
  [key: string]: string;
};
